(function(){
  'use strict';
  if(!document.querySelector('#CollectionAjaxContent'))return;
  function restore(){
    var root=document.getElementById('CollectionAjaxContent');if(!root)return;
    var images=root.querySelectorAll('.grid-product image-element img');
    images.forEach(function(img,index){
      if(img.dataset.ccImageChecked==='1')return;
      img.dataset.ccImageChecked='1';
      var dataSrc=img.getAttribute('data-src');
      var dataSrcset=img.getAttribute('data-srcset');
      if(!img.getAttribute('src') && dataSrc) img.setAttribute('src',dataSrc);
      if(!img.getAttribute('srcset') && dataSrcset) img.setAttribute('srcset',dataSrcset);
      if(index<4)img.loading='eager';
      function onError(){
        // One low-resolution retry on transient CDN/network failure. Do not loop.
        var source=img.getAttribute('src');
        if(!source || !/^https?:|^\//.test(source))return;
        try{
          var u=new URL(source,location.href);
          if(u.host!==location.host && !/\.shopify\.com$|\.shopifycdn\.com$/i.test(u.host))return;
          if(img.dataset.ccImageRetry)return;
          img.dataset.ccImageRetry='1';
          u.searchParams.set('width','360');
          img.removeAttribute('srcset');img.src=u.toString();
        }catch(e){}
      }
      img.addEventListener('error',onError,{once:true});
      if(img.complete && img.naturalWidth===0 && img.currentSrc)onError();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restore,{once:true});else restore();
  document.addEventListener('collection:reloaded',function(){requestAnimationFrame(restore);});
  document.addEventListener('collection:products-appended',function(){requestAnimationFrame(restore);});
})();
